<template>
  <div>
    <el-row>
      <el-col :span="24">
        <span class="font-title">{{
          $t("message.dataWedge.BasicSettings")
        }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">Data Wedge</span>
        <el-select size="medium" v-model="dataWedgeApp.APP_ENABLE">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.EnableLogging") }}</span>
        <el-select size="medium" v-model="dataWedgeApp.LOG_ENABLE">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="24">
        <span class="font-title">{{
          $t("message.dataWedge.administratorMode")
        }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.administratorMode") }}</span>
        <el-select
          size="medium"
          v-model="dataWedgeApp.ADMIN_ENABLEz"
          @change="openManagerPwdDialog"
        >
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="setting-box" v-if="dataWedgeApp.ADMIN_PASSz">
        <span class="setTitle">{{ $t("message.dataWedge.AdminPassword") }}</span>
        <el-input
          size="medium"
          disabled
          v-model="dataWedgeApp.ADMIN_PASSz"
        ></el-input>
      </el-col>
      <el-col :span="24">
        <!-- 开发者模式 -->
        <span class="font-title">{{
          $t("message.dataWedge.DeveloperMode")
        }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.dev_bc_start_scan") }}</span>
        <el-input size="medium" v-model="dataWedgeApp.BC_STARTSCAN"></el-input>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.dev_bc_stop_scan") }}</span>
        <el-input size="medium" v-model="dataWedgeApp.BC_STOPSCAN"></el-input>
      </el-col>
      <!-- 扫描件屏蔽 -->
      <el-col :span="24">
        <span class="secondfont-title">{{ $t("message.dataWedge.scan_key_block_title") }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.scan_key_248_block") }}</span>
        <el-select size="medium" v-model="dataWedgeApp.SWT_KEY_248_BLOCK">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.scan_key_249_block") }}</span>
        <el-select size="medium" v-model="dataWedgeApp.SWT_KEY_249_BLOCK">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.scan_key_250_block") }}</span>
        <el-select size="medium" v-model="dataWedgeApp.SWT_KEY_250_BLOCK">
          <el-option
            :label="$t('message.systemMsg.switchSelect.open')"
            :value="true"
          ></el-option>
          <el-option
            :label="$t('message.systemMsg.switchSelect.close')"
            :value="false"
          ></el-option>
        </el-select>
      </el-col>
      <!-- 关联实体按键扫描 -->
      <el-col :span="24">
        <span class="secondfont-title">{{ $t("message.dataWedge.ASSOCIATED_PHYSICAL_RDBTitle") }}</span>
      </el-col>
      <el-col :span="8" class="setting-box">
        <span class="setTitle">{{ $t("message.dataWedge.ASSOCIATED_PHYSICAL_RDB") }}</span>
        <el-select size="medium" v-model="dataWedgeApp.ASSOCIATED_PHYSICAL_RDB">
          <el-option
            :label="$t('message.dataWedge.VOLNOTHING')"
            value="0"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.VOLUP')"
            value="1"
          ></el-option>
          <el-option
            :label="$t('message.dataWedge.VOLDOWN')"
            value="2"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- 管理员密码弹框 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close='false'
      :title="$t('message.dataWedge.set_admin_pass')"
      :visible.sync="managerPwdDialog"
      width="35%"
    >
      <el-form :rules="rules" ref="ruleForm" :model="pagePwd">
        <el-form-item
          :label="$t('message.dataWedge.admin_pass')"
          label-width="220px"
          prop="ADMIN_PASSz"
        >
          <el-input
            size="medium"
            style="width: 220px"
            v-model="pagePwd.ADMIN_PASSz"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('message.dataWedge.confirmPass')"
          label-width="220px"
          prop="ReADMIN_PASSz"
        >
          <el-input
            size="medium"
            style="width: 220px"
            v-model="pagePwd.ReADMIN_PASSz"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeManagerPwdDialog">{{
          $t("message.dataWedge.cancel")
        }}</el-button>
        <el-button type="primary" @click="saveManagerPwd">{{
          $t("message.dataWedge.submit")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 管理员密码弹框end -->
  </div>
</template>

<script>
export default {
  props: {
    dataWedgeSetting: {type: Object},
  },
  data() {
    var validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("message.dataWedge.EnterAdminPwd")));
      } else {
        return callback();
      }
    };
    var validateCode2 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("message.dataWedge.confirm_pass")));
      } else {
        return callback();
      }
    };
    return {
      pagePwd: {
        ADMIN_PASSz: "", //管理员密码
        ReADMIN_PASSz: "", //二次确认密码
      },
      managerPwdDialog: false, //管理员密码弹窗
      rules: {
        ADMIN_PASSz: [
          {
            required: true,
            validator:validateCode,
            trigger: "blur",
          },
        ],
        ReADMIN_PASSz: [
          {
            required: true,
            validator:validateCode2,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    dataWedgeApp(){
      return this.dataWedgeSetting
    }
  },
  watch:{
    dataWedgeApp:{
      handler(newVal){
        this.$emit("update:dataWedgeSetting", newVal);
      },
      deep: true // 深度监听对象的变化
    }
  },
  methods: {
    openManagerPwdDialog() {
      if (this.dataWedgeApp.ADMIN_ENABLEz) {
        this.managerPwdDialog = true;
      }
    },
    closeManagerPwdDialog() {
      this.managerPwdDialog = false;
      this.dataWedgeApp.ADMIN_ENABLEz = null;
      this.pagePwd.ADMIN_PASSz = "";
      this.pagePwd.ReADMIN_PASSz = "";
      this.$refs["ruleForm"].resetFields();
    },
    // 保存管理员密码
    saveManagerPwd() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          // 验证通过
          if (this.pagePwd.ADMIN_PASSz != this.pagePwd.ReADMIN_PASSz) {
            this.$message.error(this.$t("message.dataWedge.hint_password_not_same"));
          } else {
            this.dataWedgeApp.ADMIN_PASSz = JSON.parse(JSON.stringify(this.pagePwd.ADMIN_PASSz));
            this.managerPwdDialog = false;
            this.$refs["ruleForm"].resetFields();
            this.$emit("update:dataWedgeSetting", this.dataWedgeApp);
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.font-title {
  display: inline-block;
  width: 300px;
  border-left: 6px solid #409eff;
  padding-left: 10px;
  font-size: 16px;
  color: #666666;
  font-weight: bold;
  margin: 0 0 10px 20px;
}

.setting-box {
  margin-left: 100px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-family: "Microsoft YaHei";
  font-size: 14px;

  span {
    display: inline-block;
    margin-right: 20px;
    width: 270px;
    text-align: right;
    // 超出部分用...替换
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .setting-node {
    font-size: 14px;
    display: inline;
    margin-left: 5px;
  }

  .el-input {
    width: 100%;
  }

  .el-input-number {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }
}

.setting9-box {
  margin-left: 100px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-family: "Microsoft YaHei";
  font-size: 14px;

  span {
    display: inline-block;
    margin-right: 20px;
    width: 195px;
    text-align: right;
  }

  .setting-node {
    font-size: 14px;
    display: inline;
    margin-left: 5px;
  }

  .el-input {
    width: 100%;
  }

  .el-input-number {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }
}

.setting-btns {
  width: 300px;
  float: right;
}

.wifi-addbox {
  width: 100%;
  margin-bottom: 10px;

  div {
    width: 220px;
    margin-right: 10px;
  }

  .el-input {
    width: 200px;
  }
}

.add-btns {
  border: 1px dashed #e4e7ed;
  text-align: center;
  padding: 3px;
  margin-top: 5px;
  border-radius: 3px;
}

.code-font {
  font-size: 14px;
  margin-left: 50px;
  color: #666666;
}

.switchcode-font {
  font-size: 14px;
  margin-left: 50px;
  margin-right: 10px;
  color: #666666;
}

.small-font {
  font-size: 12px;
  display: inline-block;
  // background-color: #d0e7ff;
  // color: white;
  padding: 5px;
  // border-radius: 3px;
  border-bottom: 1px solid #409eff;
  margin-left: 100px;
  margin-bottom: 10px;
}

.secondfont-title {
  display: inline-block;
  padding: 2px 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 12px;
  font-family: "Microsoft YaHei";
  margin: 0 0 20px 20px;
  color: #666666;
  background-color: #d0e7ff;
}

.el-input--small .el-input__inner {
  height: 32px;
  margin-top: 5px;
  line-height: 32px;
}

.el-input--small .el-input__inner {
  height: 32px;
  margin-top: 5px;
  line-height: 32px;
}

#tag-box {
  width: auto;
  margin-left: 5px;
}

.tags-box {
  display: grid;
  grid-template-columns: auto auto auto;
  justify-items: start;
  grid-row-gap: 10px;
}
.min-width-select {
  width: 100px;
}
</style>
